export default "__VITE_ASSET__29e80058__"